import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import UpgradeTooltip from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/UpgradeTooltip'
import useChangeView from 'modules/shift_management/hooks/useChangeView'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'

import Content from './Content'

interface Props {
  disabled?: boolean
}
const ViewSelector = ({ disabled = false }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasMonthlyView = hasFeatureFlag(ShiftManagementFeatureFlags.SHIFT_MANAGEMENT_MONTHLY_VIEW)
  const { value: canManageShifts } = useAsyncCan('shift_management.create_shifts')
  const { view, onChangeRoute } = useChangeView()

  const onGroupChange = (value: string) => {
    onChangeRoute(`${view.viewType}/${value}`)
  }

  const onViewChange = (value: string) => {
    onChangeRoute(`${value}/${view.groupType}`)
  }

  if (!hasMonthlyView && canManageShifts) {
    const description = i18n.t('shift_management.filters.view_selector.legacy_plans_alert')

    return (
      <UpgradeTooltip description={description} from="view_selector">
        <Content
          view={view}
          onGroupChange={onGroupChange}
          onViewChange={onViewChange}
          readonly={disabled}
        />
      </UpgradeTooltip>
    )
  }
  return (
    <Content
      view={view}
      onGroupChange={onGroupChange}
      onViewChange={onViewChange}
      readonly={disabled}
    />
  )
}

export default observer(ViewSelector)
